import { render, staticRenderFns } from "./ExploreCollection.vue?vue&type=template&id=584fbd66&"
import script from "./ExploreCollection.vue?vue&type=script&lang=js&"
export * from "./ExploreCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports